var $74918a1664156912$exports = {};
$74918a1664156912$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "Spalv\u0173 parinkiklis",
  "colorSwatch": "spalv\u0173 pavyzdys",
  "transparent": "skaidrus",
  "twoDimensionalSlider": "2D slankiklis"
};
export { $74918a1664156912$exports as default };